function swapElem(i1, i2, array_) {
  const array = [...array_];

  const e1 = array[i1];

  array[i1] = array[i2];
  array[i2] = e1;

  return array;
}

/**
 * Reduces an array of options into a configuration object.
 *
 * @param {object} acc - configuration object.
 * @param {string} option - option name.
 * @return {*} - A configuration object.
 */
function configReducer(acc, option) {
  acc[option] = true;

  return acc;
}

function csvStringToArray(options, value) {
  const { sort = false } = options;
  if (!value) {
    return [];
  }

  const values = value.split(",");
  if (sort) {
    values.sort();
  }

  return values;
}

export { configReducer, csvStringToArray, swapElem };
